import { CommonResponse } from "@gtpl/shared-models/masters";
import connection from "./connection";
import axios from "axios";
import { CollectionsFilters,BrcReq, CollectionIdRequest, CollectionsReq, DdbCollectionsReq, PaymentTypeReq, ReceivablesDetailsReq, ReceivablesSummaryReq, SaleReq, ScriptGenReq, iceGateReq, RodtepReportReq, iceGateVerification, SaleReceiveReq, DutyDrawBackDateReq, DutyDrawBackReportReq, IgstCollectionsReq, PayableRequest, RmDateReq, PayableFilterRequest, AgingReq, IgstReportReq, RmInvoiceDataForPayablesReq, RmPayblesReq } from "libs/shared-models/finance/src";
import { ProductionLogRequest } from "libs/shared-models/production-management/src/lib/production-inv/production-log.req";
import { IdRequest } from "@gtpl/shared-models/gtpl";
import { PayablesDashboardReq } from "@gtpl/shared-models/raw-material-procurement";

export class CollectionsService{
    URL = connection.DEPLOY_URL + '/collections';
    
    async getCollection(req:PaymentTypeReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getCollection',req)
            .then(res => {
                return res.data
            })
    }

    async generatePayment(req:CollectionsReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/generatePayment',req)
            .then(res => {
                return res.data
            })
    }

    async getExportReceivablesData(req:CollectionsFilters):Promise<CommonResponse>{
        return await axios.post(this.URL + '/getExportReceivablesData',req)
        .then(res => {
            return res.data
        })
    }
    
    async getDutyDrawBackData(req:CollectionsFilters):Promise<CommonResponse>{
        return await axios.post(this.URL + '/getDutyDrawBackData',req)
        .then(res=>
            {
                return res.data
            }
        )
    }
    async generateDdbPayment(req:DdbCollectionsReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/generateDdbPayment',req)
            .then(res => {
                return res.data
            })
    }
    async getBuyers(req:PaymentTypeReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getBuyers',req)
            .then(res => {
                return res.data
            })
    }

    async getBuyerSDropDown(): Promise<CommonResponse>{
        return await axios.get(this.URL + '/getBuyerSDropDown')
        .then(res => {
            return res.data
        })
    }

    async getInvoiceNumber(): Promise<CommonResponse>{
        return await axios.get(this.URL + '/getInvoiceNumber')
        .then(res => {
            return res.data
        })
    }

    async getReceivablesSummaryReport(req:ReceivablesSummaryReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getReceivablesSummaryReport',req)
            .then(res => {
                return res.data
            })
    }
    async getReceivablesDetailsReport(req:ReceivablesDetailsReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getReceivablesDetailsReport',req)
            .then(res => {
                return res.data
            })
    }
    async getExpectedReceivablesReport():Promise<CommonResponse>{
        return await axios.post(this.URL + '/getExpectedReceivablesReport')
        .then(res =>{
            return res.data
        })
    }
    async getShippedPoData(req:any):Promise<CommonResponse>{
        return await axios.post(this.URL + '/getShippedPoData',req)
        .then(res =>{
            return res.data
        })
    }
    async iceGateUpdate(req:iceGateReq):Promise<CommonResponse>{
        return await axios.post(this.URL + '/iceGateUpdate',req)
        .then(res =>{
            return res.data
        })
    }
    async getBrcPoData(req:any):Promise<CommonResponse>{
        return await axios.post(this.URL + '/getBrcPoData',req)
        .then(res =>{
            return res.data
        })
    }
    async brcUpdate(req:BrcReq):Promise<CommonResponse>{
        return await axios.post(this.URL + '/brcUpdate',req)
        .then(res =>{
            return res.data
        })
    }
    async getScriptGenPoData(req:any):Promise<CommonResponse>{
        return await axios.post(this.URL + '/getScriptGenPoData',req)
        .then(res =>{
            return res.data
        })
    }
    async getBrcInfo(req:CollectionIdRequest):Promise<CommonResponse>{
        return await axios.post(this.URL + '/getBrcInfo',req)
        .then(res =>{
            return res.data
        })
    }
   
    async createScriptGeneration(req:ScriptGenReq):Promise<CommonResponse>{
        return await axios.post(this.URL + '/createScriptGeneration',req)
        .then(res =>{
            return res.data
        })
    }
    async getLicsenseInfo(req:CollectionIdRequest):Promise<CommonResponse>{
        return await axios.post(this.URL + '/getLicsenseInfo',req)
        .then(res =>{
            return res.data
        })
    }
    async createSale(req:SaleReq):Promise<CommonResponse>{
        return await axios.post(this.URL + '/createSale',req)
        .then(res =>{
            return res.data
        })
    }
    async getSalePoData():Promise<CommonResponse>{
        return await axios.post(this.URL + '/getSalePoData')
        .then(res =>{
            return res.data
        })
    }

    async getRodtepReport(req:RodtepReportReq):Promise<CommonResponse>{
        console.log(req,"reqqqqqqqqqqqqqqqshareddddddddddd")
        return await axios.post(this.URL + '/getRodtepReport',req)
        .then(res =>{
            return res.data
        })
    }
    
    async getRodTepAbstractReport(req?:ProductionLogRequest):Promise<CommonResponse>{
        return await axios.post(this.URL + '/getRodTepAbstractReport',req)
        .then(res =>{
            return res.data
        })
    }
    async getRodtepData(req:CollectionsFilters):Promise<CommonResponse>{
        return await axios.post(this.URL + '/getRodtepData',req)
        .then(res => {
            return res.data
        })
    }

    async iceGateVerification(req:iceGateVerification):Promise<CommonResponse>{
        return await axios.post(this.URL + '/iceGateVerification',req)
        .then(res => {
            return res.data
        })
    }    async getDutyDrawBackTotals(req:DutyDrawBackDateReq):Promise<CommonResponse>{
        return await axios.post(this.URL + '/getDutyDrawBackTotals',req)
        .then (res => {
            return res.data
        })
    }

    async getReceivePoData(req:any):Promise<CommonResponse>{
        return await axios.post(this.URL + '/getReceivePoData',req)
        .then(res => {
            return res.data
        })
    }
    async updateSaleReceived(req:SaleReceiveReq):Promise<CommonResponse>{
        return await axios.post(this.URL + '/updateSaleReceived',req)
        .then(res => {
            return res.data
        })
    }

    async getDutyDrawBackReport(req:DutyDrawBackReportReq):Promise<CommonResponse>{
        return await axios.post(this.URL + '/getDutyDrawBackReport',req)
        .then(res =>{
            return res.data
        })
    }
async getIGSTAmountReport(req:any):Promise<CommonResponse>{
        return await axios.post(this.URL + '/getIGSTAmountReport',req)
        .then(res =>{
            return res.data
        })
    }
    async getRMInvoiceWiseData(req:AgingReq):Promise<CommonResponse>{
        return await axios.post(this.URL + '/getRMInvoiceWiseData',req)
        .then(res =>{
            return res.data
        })
    }
    async getPMInvoiceWiseData(req:AgingReq):Promise<CommonResponse>{
        return await axios.post(this.URL + '/getPMInvoiceWiseData',req)
        .then(res =>{
            return res.data
        })
    }
    async getVendorPackTaxData(req:AgingReq):Promise<CommonResponse>{
        return await axios.post(this.URL + '/getVendorPackTaxData',req)
        .then(res =>{
            return res.data
        })
    }
    async getVendorRMTaxData(req:AgingReq):Promise<CommonResponse>{
        return await axios.post(this.URL + '/getVendorRMTaxData',req)
        .then(res =>{
            return res.data
        })
    }
    async getIGSTAgingReport(req:any):Promise<CommonResponse>{
        return await axios.post(this.URL + '/getIGSTAgingReport',req)
        .then(res =>{
            return res.data
        })
    }
    async getAllInvoiceNumber():Promise<CommonResponse>{
        return await axios.post(this.URL + '/getAllInvoiceNumber')
        .then(res =>{
            return res.data
        })
    }
    async generateIgstPayment(req:IgstCollectionsReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/generateIgstPayment',req)
            .then(res => {
                return res.data
            })
    }
    async getIgstData(req:CollectionsFilters):Promise<CommonResponse>{
        return await axios.post(this.URL + '/getIgstData',req)
        .then(res=>
            {
                return res.data
            }
        )
    }
    async getPackingInvoices(req:PayableFilterRequest):Promise<CommonResponse>{
        return await axios.post(this.URL + '/getPackingInvoices',req)
        .then(res=>
            {
                return res.data
            }
        )
    }
     async getRmInvoices():Promise<CommonResponse>{
        return await axios.post(this.URL + '/getRmInvoices')
        .then(res=>
            {
                return res.data
            }
        )
    }
     async getPackingPayables(req:PayableFilterRequest ):Promise<CommonResponse>{
        return await axios.post(this.URL + '/getPackingPayables',req)
        .then(res=>
            {
                return res.data
            }
        )
    }
     async getRmPayables(req:PayableFilterRequest):Promise<CommonResponse>{
        return await axios.post(this.URL + '/getRmPayables',req)
        .then(res=>
            {
                return res.data
            }
        )
    }
        async getPackingVendors(req:PayableFilterRequest):Promise<CommonResponse>{
        return await axios.post(this.URL + '/getPackingVendors',req)
        .then(res=>
            {
                return res.data
            }
        )
    }
     async getRmSuppliers():Promise<CommonResponse>{
        return await axios.post(this.URL + '/getRmSuppliers')
        .then(res=>
            {
                return res.data
            }
        )
    }
     async savePayables(req:PayableRequest):Promise<CommonResponse>{
        return await axios.post(this.URL + '/savePayables',req)
        .then(res=>
            {
                return res.data
            }
        )
    }

    async getPayablesForPacking(req:PayableFilterRequest):Promise<CommonResponse>{
        return await axios.post(this.URL + '/getPayablesForPacking',req)
        .then(res=>
            {
                return res.data
            }
        )
    }

    async getPayablesForRM(req:PayableFilterRequest):Promise<CommonResponse>{
        return await axios.post(this.URL + '/getPayablesForRM',req)
        .then(res=>
            {
                return res.data
            }
        )
    }
     async getPayablesInvoices(req:PayableFilterRequest):Promise<CommonResponse>{
        return await axios.post(this.URL + '/getPayablesInvoices',req)
        .then(res=>
            {
                return res.data
            }
        )
    }
    async getPayablesSuppliers(req:PayableFilterRequest):Promise<CommonResponse>{
        return await axios.post(this.URL + '/getPayablesSuppliers',req)
        .then(res=>
            {
                return res.data
            }
        )
    }
    async getOverDueReceivablesinvoices(req:any):Promise<CommonResponse>{
        return await axios.post(this.URL + '/getOverDueReceivablesinvoices',req)
        .then(res=>
            {
                return res.data
            }
        )
    }
    async getOverDueReceivablesRanges(req:any):Promise<CommonResponse>{
        return await axios.post(this.URL + '/getOverDueReceivablesRanges',req)
        .then(res=>
            {
                return res.data
            }
        )
    }
    async getOverDueReceivables(req:any):Promise<CommonResponse>{
        return await axios.post(this.URL + '/getOverDueReceivables',req)
        .then(res=>
            {
                return res.data
            }
        )
    }
    async getRMDueAmountData(req?: PayablesDashboardReq):Promise<CommonResponse>{
        return await axios.post(this.URL + '/getRMDueAmountData',req)
        .then(res=>
            {
                return res.data
            }
        )
    }
    async getRmPaidAmountData( req:RmDateReq):Promise<CommonResponse>{
        return await axios.post(this.URL + '/getRmPaidAmountData',req)
        .then(res=>
            {
                return res.data
            }
        )
    }

    async getRmagingDuesData( req:PayablesDashboardReq):Promise<CommonResponse>{
        return await axios.post(this.URL + '/getRmagingDuesData',req)
        .then(res=>
            {
                return res.data
            }
        )
    }
    
    async getTotalIncentiveAmount( req?:PayablesDashboardReq):Promise<CommonResponse>{
        return await axios.post(this.URL + '/getTotalIncentiveAmount',req)
        .then(res=>
            {
                return res.data
            }
        )
    }
async getTotalReceivedIncentiveAmount( req?:PayablesDashboardReq):Promise<CommonResponse>{
        return await axios.post(this.URL + '/getTotalReceivedIncentiveAmount',req)
        .then(res=>
            {
                return res.data
            }
        )
    }
    async getTotalOverDueIncentiveAmount( req?:PayablesDashboardReq):Promise<CommonResponse>{
        return await axios.post(this.URL + '/getTotalOverDueIncentiveAmount',req)
        .then(res=>
            {
                return res.data
            }
        )
    }
    async getTotalRodtepDueIncentive( req?:PayablesDashboardReq):Promise<CommonResponse>{
        return await axios.post(this.URL + '/getTotalRodtepDueIncentive',req)
        .then(res=>
            {
                return res.data
            }
        )
    }
    async getTotalDdbDueIncentive( req?:PayablesDashboardReq):Promise<CommonResponse>{
        return await axios.post(this.URL + '/getTotalDdbDueIncentive',req)
        .then(res=>
            {
                return res.data
            }
        )
    }
    async getTotalIgstDueIncentive( req?:PayablesDashboardReq):Promise<CommonResponse>{
        return await axios.post(this.URL + '/getTotalIgstDueIncentive',req)
        .then(res=>
            {
                return res.data
            }
        )
    }
    async getRodtepDueRanges( req?:PayablesDashboardReq):Promise<CommonResponse>{
        return await axios.post(this.URL + '/getRodtepDueRanges',req)
        .then(res=>
            {
                return res.data
            }
        )
    }
    async getDdbDueRanges( req?:PayablesDashboardReq):Promise<CommonResponse>{
        return await axios.post(this.URL + '/getDdbDueRanges',req)
        .then(res=>
            {
                return res.data
            }
        )
    }
async getIgstDueRangess( req?:PayablesDashboardReq):Promise<CommonResponse>{
        return await axios.post(this.URL + '/getIgstDueRangess',req)
        .then(res=>
            {
                return res.data
            }
        )
    }
    async getDdbDueInvoices( req?:PayablesDashboardReq):Promise<CommonResponse>{
        return await axios.post(this.URL + '/getDdbDueInvoices',req)
        .then(res=>
            {
                return res.data
            }
        )
    }
    async getIgstDueInvoices( req?:PayablesDashboardReq):Promise<CommonResponse>{
        return await axios.post(this.URL + '/getIgstDueInvoices',req)
        .then(res=>
            {
                return res.data
            }
        )
    }
     async getTotalReciveableInvoices( req?:PayablesDashboardReq):Promise<CommonResponse>{
        return await axios.post(this.URL + '/getTotalReciveableInvoices',req)
        .then(res=>
            {
                return res.data
            }
        )
    }
    async getSalesInvoiceAmount( ):Promise<CommonResponse>{
        return await axios.post(this.URL + '/getSalesInvoiceAmount')
        .then(res=>
            {
                return res.data
            }
        )
    }
    async getSalesNetWeight():Promise<CommonResponse>{
        return await axios.post(this.URL + '/getSalesNetWeight')
        .then(res=>
            {
                return res.data
            }
        )
    }
    async getContainerShippedSoCount(req?:RmDateReq):Promise<CommonResponse>{
        return await axios.post(this.URL + '/getContainerShippedSoCount',req)
        .then(res=>
            {
                return res.data
            }
        )
    }
        async getRodtepDueInvoices( req?:PayablesDashboardReq):Promise<CommonResponse>{
        return await axios.post(this.URL + '/getRodtepDueInvoices',req)
        .then(res=>
            {
                return res.data
            }
        )
    }
        async rmDueData( req:PayablesDashboardReq):Promise<CommonResponse>{
            console.log(req,"reqqqqqqqq")
             return await axios.post(this.URL + '/rmDueData',req)
        .then(res=>
            {
                return res.data
            }
        )
        }

        async getCompanysForCeoDashboard():Promise<CommonResponse>{
            return await axios.post(this.URL + '/getCompanysForCeoDashboard')
       .then(res=>
           {
               return res.data
           }
       )
       }
        async getPackingPayableInvoices(req?:PayableFilterRequest ):Promise<CommonResponse>{
        return await axios.post(this.URL + '/getPackingPayableInvoices',req)
        .then(res=>
            {
                return res.data
            }
        )
    }
     async getRmPayableInvoices(req?:PayableFilterRequest):Promise<CommonResponse>{
        return await axios.post(this.URL + '/getRmPayableInvoices',req)
        .then(res=>
            {
                return res.data
            }
        )
    }
      async getVendorRMTaxDataReport(req?:AgingReq):Promise<CommonResponse>{
        return await axios.post(this.URL + '/getVendorRMTaxDataReport',req)
        .then(res=>
            {
                return res.data
            }
        )
    }
      async getVendorPackTaxDataReport(req?:AgingReq):Promise<CommonResponse>{
        return await axios.post(this.URL + '/getVendorPackTaxDataReport',req)
        .then(res=>
            {
                return res.data
            }
        )
    }

               async getRmInvoiceDataForPayables(req?: RmPayblesReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getRmInvoiceDataForPayables',req)
            .then(res => {
                return res.data
            })
    }
               async getRmInvoiceDataForView(req?:any): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getRmInvoiceDataForView',req)
            .then(res => {
                return res.data
            })
    }
}
